import { FC, ReactNode, useEffect, useState } from "react";
import "./index.css";
import { ConfigType, PluginconfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { usePluginspace } from "../../hooks/usePluginspace";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { Loading } from "../../components/Loading";
import { StoreInfoCard } from "../../components/storeInfocards/storeInfocards";
import api from "../../services/api";
import {
  LocationType,
  PluginspaceContext,
} from "../../contexts/PluginspaceContext";
import { StoreInfoContact } from "../../components/StoreInfoColntact/StoreInfoContact";
import { StoreInfoHours } from "../../components/StoreInfoHours/StoreInfoHours";
import { StoreInfoAddress } from "../../components/StoreInfoAddress/StoreInfoAddress";
import { StoreInfoSocialMedia } from "../../components/StoreInfoSocialMedia/storeInfoSocialMedia";

type HourType = {
  id: number;
  day: string;
  hour: string;
  weekday: number;
};

type HourResponseType = {
  id: number;
  weekday: number;
  timeStart: string;
  timeStart2: string;
  timeEnd: string;
  timeEnd2: string;
};

type RedeSocial = {
  id: number;
  name: string;
  url: string;
  type: string;
};

type StoreInfoProps = {
  onClose: () => void;
  orderIdExt: string;
};

const StoreInfo: FC<StoreInfoProps> = ({ onClose, orderIdExt }) => {
  const [loadingHeader, setLoadingHeader] = useState(true);
  const { getLocations, pluginspace } = usePluginspace();
  const [config, setConfig] = useState<ConfigType | void>();
  const [endereco, setEndereco] = useState<LocationType>();
  const { getAppConfig, getPluginconfig } = useAppConfig();
  const [pluginconfigs, setPluginconfigs] = useState<PluginconfigType[]>([]);

  const [hours, setHours] = useState<HourType[]>([]);
  const [loading, setLoading] = useState(false);
  const [redeSocial, setRedeSocial] = useState<RedeSocial[]>([]);

  const { getToken } = usePluginspace();

  async function getHours() {
    await api
      .get(`/api/location-operation`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const newHours: Array<HourType> = [];
        response.data.data.map((hour: HourResponseType) => {
          let weekday = "";
          switch (hour.weekday) {
            case 0:
              weekday = "Domingo";
              break;
            case 1:
              weekday = "Segunda";
              break;
            case 2:
              weekday = "Terça";
              break;
            case 3:
              weekday = "Quarta";
              break;
            case 4:
              weekday = "Quinta";
              break;
            case 5:
              weekday = "Sexta";
              break;
            case 6:
              weekday = "Sábado";
              break;
          }
          if (weekday != "") {
            if (
              hour.timeStart != "00:00:00" ||
              hour.timeEnd != "00:00:00" ||
              hour.timeStart2 != "00:00:00" ||
              hour.timeEnd2 != "00:00:00"
            ) {
              if (hour.timeStart2 != hour.timeEnd2) {
                newHours.push({
                  id: hour.id,
                  day: `${weekday}`,
                  weekday: hour.weekday,
                  hour: `${hour.timeStart.substring(
                    0,
                    5
                  )} - ${hour.timeEnd.substring(
                    0,
                    5
                  )} e ${hour.timeStart2.substring(
                    0,
                    5
                  )} - ${hour.timeEnd2.substring(0, 5)}`,
                });
              } else {
                newHours.push({
                  id: hour.id,
                  weekday: hour.weekday,
                  day: `${weekday}`,
                  hour: `${hour.timeStart.substring(
                    0,
                    5
                  )} - ${hour.timeEnd.substring(0, 5)}`,
                });
              }
            }
          }
        });
        setHours(newHours);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getendereco() {
    const loc = await getLocations();
    setEndereco(loc.find((address) => address.type === "address"));
  }
  async function getPluginconfigs() {
    setPluginconfigs(await getPluginconfig());
  }

  async function getConfig() {
    setLoadingHeader(true);
    const conf = await getAppConfig();
    setConfig(conf);
    setLoadingHeader(false);
    return conf;
  }

  async function getSocialMedia() {
    setLoading(true);
    await api
      .get(
        `/api/socialnetwork`,

        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data && response.data.success) {
          setRedeSocial(response.data.data);
        } else {
          setRedeSocial([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  async function loadAll() {
    try {
      setLoading(true);
      await Promise.all([
        getConfig(),
        getHours(),
        getPluginconfigs(),
        getendereco(),
        getSocialMedia(),
      ]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return false;
    }
  }

  useEffect(() => {
    loadAll();
  }, []);

  if (pluginspace.type === "food") {
    return (
      <div className="info-loja-food">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        <div className="content-info-loja">
          {loading ? (
            <div
              style={{
                width: "100vw",
                height: "100vh",
                position: "fixed",
                top: 0,
                left: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loading
                type="spinningBubbles"
                color="#FFF"
                width={64}
                height={64}
              />
            </div>
          ) : (
            <div
              className="info-card-food"
              style={{
                maxWidth: "500px",
                margin: "0 auto",
                padding: "1rem 3rem",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0px 0px 1rem 0px",
                  }}
                >
                  <h3 className="loja-cancel">Cancelar pedido</h3>{" "}
                  <div
                    className="x-container"
                    style={{ cursor: "pointer" }}
                    onClick={onClose}
                  >
                    {" "}
                    <span className="line line1"></span>
                    <span className="line line2"></span>
                  </div>
                </div>
                <p
                  style={{
                    paddingBottom: "1rem",
                  }}
                >
                  {`Para solicitar o cancelamento do pedido ${orderIdExt} entre em contato com a loja`}
                </p>
              </div>
              <StoreInfoContact
                config={config}
                plugins={pluginconfigs}
                redeSocial={redeSocial}
              />
            </div>
          )}
        </div>
        {!loadingHeader && (
          <Menu
            activeMenu="info"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    );
  }

  return (
    <div className="info-loja">
      {!loadingHeader && (
        <Header
          background={
            config?.webappcolor.backgroundheader
              ? config?.webappcolor.backgroundheader
              : "#F5F5F5"
          }
          colorIcon={
            config?.webappcolor.iconsheader
              ? config.webappcolor.iconsheader
              : "#636363"
          }
          logo={config?.icon ? config.icon : ""}
          backgroundCart={
            config?.webappcolor.backgroundcart
              ? config.webappcolor.backgroundcart
              : "#FFBA49"
          }
          fontCart={
            config?.webappcolor.fontcart ? config.webappcolor.fontcart : "#000"
          }
          noSales={
            config &&
            config?.content &&
            config?.content.pdv &&
            config?.content.pdv.noSales
              ? config.content.pdv.noSales
              : false
          }
        />
      )}
      <div className="content-info-loja">
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="content-loja">
            {/* <StoreInfoContact config={config} plugins={pluginconfigs} /> */}
            <StoreInfoHours hours={hours} config={config} />
            <StoreInfoAddress endereco={endereco} config={config} />
            <div
              style={{
                padding: "0px 13px",
              }}
            >
              {/* <StoreInfoSocialMedia /> */}
            </div>
          </div>
        )}
      </div>
      {!loadingHeader && (
        <Menu
          activeMenu="info"
          fontColor={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          activeFontColor={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#000"
          }
          backgroundMenu={
            config?.webappcolor.backgroundfooter
              ? config?.webappcolor.backgroundfooter
              : "#F5F5F5"
          }
          colorIcons={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          highlightColorIcons={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#636363"
          }
          backgroundCart={
            config?.webappcolor.backgroundcart
              ? config.webappcolor.backgroundcart
              : "#FFBA49"
          }
          fontCart={
            config?.webappcolor.fontcart ? config.webappcolor.fontcart : "#000"
          }
          noSales={
            config &&
            config?.content &&
            config?.content.pdv &&
            config?.content.pdv.noSales
              ? config.content.pdv.noSales
              : false
          }
        />
      )}
    </div>
  );
};

export { StoreInfo };
